import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import LeadsCard from './leadsCard';
import generatePath from '~settings/routing';

const LeadsPopup = ({ studentId, data, wrapper }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const offsetTop = 5;
  const offsetLeft = 10;

  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [pointer, setPointer] = useState('bottom');

  const popup = useRef();

  const handleViewMore = e => {
    e.stopPropagation();
    e.preventDefault();
    history.push(generatePath('students.detail', { id: studentId, ongoing: true }));
  };

  useEffect(() => {
    if (wrapper?.current && popup?.current) {
      const rect = wrapper.current.getBoundingClientRect();
      const popupHeight = popup.current.offsetHeight || 0;

      let top = rect.top - popupHeight - offsetTop + window.scrollY;
      const left = rect.left + offsetLeft + window.scrollX;

      if (top < 0) {
        top = rect.bottom + offsetTop + window.scrollY;
        setPointer('top');
      }

      setPosition({
        top,
        left,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wrapper?.current, popup?.current]);

  const popupContent = (
    <div
      className="leads-popup"
      style={{
        display: `${position.top && position.left ? 'block' : 'none'}`,
        top: `${position.top}px`,
        left: `${position.left}px`,
      }}
      ref={popup}
    >
      <div className="leads-popup__header">{t('cms:cms.students.list.column.ongoing_leads')}</div>
      <div className="leads-popup__content">
        {data.map((item, index) => index < 3 && <LeadsCard data={item} key={index} />)}
      </div>
      {data.length > 3 && (
        <a className="leads-popup__more" href="#" onClick={handleViewMore}>
          {t('cms:cms.students.list.column.ongoing_leads.more')}
        </a>
      )}
      <div className={`leads-popup__pointer leads-popup__pointer-${pointer}`} />
    </div>
  );

  return ReactDOM.createPortal(popupContent, document.body);
};

export default LeadsPopup;
